module.exports = __webpack_public_path__ + "static/media/Icon_delete_solid.0c5765a8.svg";